import React, { useEffect } from 'react';
import Wallet from './Wallet';

const WalletIndex = () => {
	useEffect(() => {
		const resizeEvent = document.createEvent('HTMLEvents');
		resizeEvent.initEvent('resize', true, false);
		window.dispatchEvent(resizeEvent);
		let timer1 = setTimeout(() => {
			window.dispatchEvent(resizeEvent);
		}, 10);

		return () => {
			clearTimeout(timer1);
		};
	}, []);

	return (
		<>
			<Wallet />
		</>
	);
};

export default WalletIndex;
